import axios from "axios";
import { camelizeKeys } from 'humps';
import { legendMap } from '../data/alimtalkConst'
axios.defaults.withCredentials = true;
axios.interceptors.response.use((response) => {
  response.data = camelizeKeys(response.data);
  return response;
});

const API_BASE = `https://fb-alimtalk.epinet.kr`;
// const API_BASE = `http://localhost:8000`;


const getRefinedFBSpots = (data) => {
  const getColor = (match_status) => {
    return legendMap[match_status];
  };


  let newData = data && data.length > 0 ? data : [];
  return newData.map((item) => {
    return {
      ...item,
      'is_same': getColor(item.matchStatus),
    };
  });
};

export const getPesticideList = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetYear,
  targetRegion
) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region-pesticide/`;
  const params = {
    year: targetYear,
    plant: targetCrop.title,
    ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }),
  };
  try {
    setLoadingCallBack(true);
    const response = await axios.get(api, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("약제 정보 조회에 실패하였습니다.");
  }
  setLoadingCallBack(false);
};

export const getSendLog = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetYear,
  targetRegion,
  stationId = null
) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region-accumulative-send-count/`;
  const params = stationId
    ? { plant: targetCrop.title, year: targetYear, st: stationId, ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }) }
    : { plant: targetCrop.title, year: targetYear, ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }) };
  try {
    setLoadingCallBack(true);
    const response = await axios.get(api, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("발송 로그 조회에 실패하였습니다.");
  }
  setLoadingCallBack(false);
};

export const getRegionIndexSendCount = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetRegion
) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region-accumulative-send-count/index/`;
  const params = {
    plant: targetCrop.title,
    ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }),
  };
  try {
    setLoadingCallBack(true);
    const response = await axios.get(api, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("차수별 발송률 조회에 실패하였습니다.");
  }
  setLoadingCallBack(false);
};

export const getRegionDateSendCount = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetRegion
) => {
  const api = `${API_BASE}/api/alimtalk-monitor/region-accumulative-send-count/date/`;
  const params = {
    plant: targetCrop.title,
    ...(targetRegion && targetRegion.region !== "all" && { region: targetRegion.region }),
  };
  try {
    setLoadingCallBack(true);
    const response = await axios.get(api, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("일자별 발송 농가 수 조회에 실패하였습니다.");
  }
  setLoadingCallBack(false);
};

export const getSigunguList = async (setDataCallBack, setErrorCallBack, targetCrop, targetYear) => {
  const params = {
    plant: targetCrop.title,
    year: targetYear,
  };
  const api = `${API_BASE}/api/alimtalk-monitor/region`;
  try {
    const response = await axios.get(api, { params: { ...params } })
    const data = response.data;
    setDataCallBack([{ region: 'all', regionName: "전체" }, ...data]);
  } catch (e) {
    setErrorCallBack(e);
    alert("시군 목록 조회에 실패하였습니다.");
  }
};

export const getFBSpotsAlimtalk = async (
  setDataCallBack,
  setLoadingCallBack,
  setErrorCallBack,
  targetCrop,
  targetYear,
  targetRegion
) => {
  const params = {
    plant: targetCrop.title,
    ...(targetRegion && targetRegion.region !== 'all' && { region: targetRegion.region }),
  };

  const api = `${API_BASE}/api/alimtalk-monitor/region-station-send-count`;

  try {
    setLoadingCallBack(true);
    setErrorCallBack();
    await axios.get(api, { params: { ...params } }).then((response) => {
      const data = response.data;
      setDataCallBack(
        getRefinedFBSpots(data)
      );
    });
  } catch (e) {
    setErrorCallBack(e);
    alert("해당 API 호출에 실패하였습니다. 재시도하여 주세요.");
  }
  setLoadingCallBack(false);
};

export const getRegionSido = async (setDataCallBack, setErrorCallBack) => {
  try {
    const response = await axios.get(`${API_BASE}/api/fireblight-monitor/region-sido/`);
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("시도 목록 조회에 실패하였습니다.");
  }
};

export const getWeeklyBirMaxCount = async (
    setDataCallBack,
    setErrorCallBack,
    { start, end, regionMainCd }
) => {
  const params = {
    start,
    end,
    ...(regionMainCd && { region_main_cd: regionMainCd }),
  };

  try {
    const response = await axios.get(`${API_BASE}/api/fireblight-monitor/region-sigun-weekly-count/`, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("집계 데이터 조회에 실패하였습니다.");
  }
};

export const getWeeklySidoBirMaxCount = async (
    setDataCallBack,
    setErrorCallBack,
    { start, end, plant, regionMainCd }
) => {
  const params = {
    start,
    end,
    plant,
    ...(regionMainCd && { region_main_cd: regionMainCd }),
  };

  try {
    const response = await axios.get(`${API_BASE}/api/fireblight-monitor/region-sido-weekly-count/`, { params });
    setDataCallBack(response.data);
  } catch (e) {
    setErrorCallBack(e);
    alert("시도 집계 데이터 조회에 실패하였습니다.");
  }
};